import { useQuery } from "@tanstack/react-query";
import { Bucket } from "@/shared/model/Bucket";
import { getBuckets } from "@/pages/sy/repositories/ChargeRepository";

export const useBucketsQuery = (onError?: (error: Error) => void) => {
  return useQuery({
    queryKey: ["buckets"],
    queryFn: async ({ signal }) => {
      const resp = await getBuckets(signal);
      if (resp.ok) {
        return (resp.data?.tables?.[0]?.rows ?? []) as Bucket[];
      }
      throw new Error(resp.message);
    },
    onError,
  });
};
